//Library Imports
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Tooltip, Typography } from "antd";
import styled from "styled-components";

//Local Imports
import { ReactComponent as BackArrow } from "../../../assets/img/icons/Back_Arrow.svg";

interface IStickyHeaderAnalyticsProps {
  showBack: boolean;
  label: string;
  title: string;
  externalRedirect?: () => void;
}
const StickyHeaderAnalytics: React.FC<IStickyHeaderAnalyticsProps> = ({
  showBack,
  children,
  label,
  title,
  externalRedirect,
}) => {
  const history = useHistory();
  const { Paragraph } = Typography;
  const [ellipsisState, setEllipsisState] = useState(false);
  const redirect = (e: any) => {
    history.goBack();
    localStorage.setItem("analytics_back_url", "");
    return false;
  };
  return (
    <ContentContainer>
      {showBack && (
        <div className="d-flex flex-row bottom-margin align-items-center">
          <a onClick={externalRedirect ?? redirect} id="header-back-btn" href="javascript: void(0);">
            <BackArrow className="top-margin cursor-pointer" />
          </a>
          <div className="verticalLine top-margin me-2"></div>
        </div>
      )}
      <div className="d-flex justify-content-between full-width">
        <div className="label-container flex-grow-1">
          {/* <h1 className="label-header">{title}</h1> */}
          {/* <Tooltip className="label-header" placement="top" title={ellipsisState ? title : undefined}> */}
          <Paragraph
            className="label-header"
            ellipsis={{
              rows: 1,
              tooltip: title,
            }}
          >
            {title}
          </Paragraph>
          {/* </Tooltip> */}

          <span className="sub-label-header">{label}</span>
        </div>
        <div className="header-tab">{children}</div>
      </div>
    </ContentContainer>
  );
};

export default StickyHeaderAnalytics;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  .full-width {
    width: 100%;
    justify-content: space-between;
  }
  .search-icon-contianer {
    height: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
  }
  .verticalLine {
    height: 24px;
    border: 1px solid #dddddd;
    width: 1px;
    padding: 0;
    background: #dddddd;
    margin-left: 11px;
  }
  .label-container {
    display: flex;
    justify-content: start;
    height: 100%;
    align-items: center;
    flex-direction: column;
    align-items: flex-start;
  }
  .label-header {
    color: #424b50;
    font-size: 36px;
    font-weight: 600;
    line-height: 47px;
    margin-bottom: 0px;
    display: block;
    font-family: "Roboto Slab", serif;
    white-space: nowrap;
    min-width: calc(100% - 150px);
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 28px;
      line-height: 33px;
    }
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 28px;
      line-height: 33px;
    }
  }
  .sub-label-header {
    color: #424b50;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    margin-bottom: 0px;
    display: block;
    font-family: "Roboto Slab", serif;
    white-space: nowrap;
    /* margin-top: -10px; */
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      line-height: 12px;
    }
  }
  .header-tab {
    > div {
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-align-items: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      padding-top: 8px;
      margin-left: -5px;
    }
  }
`;
